<script setup>
/**
 * The "Live" pill shown on every self-refreshing Reports panel.
 *
 * Extracted from `overview/MetricCard.vue` so the heatmaps, the agent and team
 * panels, and the conversation stats all render the same badge.
 */
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <span
    class="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium tracking-wide uppercase rounded-full bg-n-ruby-3 text-n-ruby-11"
  >
    <span class="rounded-full size-1.5 bg-n-ruby-9" />
    {{ t('OVERVIEW_REPORTS.LIVE') }}
  </span>
</template>
